import { isDOM } from '@app/shared/predicates'
import { identifyStatusPageIncident } from './appcues-status-page'
import { setupAppcuesErrorMonitoring } from './appcues-error-monitoring'
import { reidentifyAppcuesUser } from './reidentify-appcues-user'

function trackVisit(): void {
  if (!window.Appcues) {
    return
  }

  if (!document.documentElement.hasAttribute('data-turbolinks-preview')) {
    console.log('Appcues: Tracking page view manually')
    window.Appcues.page()
    trackSfPageVisit()
  }
}

function reloadAppcues(): void {
  window.onDomLoad(($dom) => {
    console.log('Appcues: DOM loaded')
    if (isDOM($dom[0])) {
      trackVisit()
    }
  })
}

export function identifyPresentationMode(presentationMode: boolean): void {
  reidentifyAppcuesUser(
    { presentationMode },
    'Failed to re-identify presentation mode'
  )
}

export function trackSfPageVisit(): void {
  const element = document.querySelector(
    '[data-behaviour="appcues-track-visit"]'
  )

  if (!element) {
    return
  }

  const properties: Record<string, string> = {}

  Array.from(element.attributes).forEach((attr) => {
    if (attr.name.startsWith('data-') && attr.name !== 'data-behaviour') {
      const key = attr.name.replace(/^data-/, '').replace(/-/g, '_')
      properties[key] = attr.value
    }
  })

  if (Object.keys(properties).length > 0 && window.Appcues?.track) {
    console.log('Appcues: Tracking page view with properties:', properties)
    window.Appcues.track('SfPageVisit', properties)
  }
}

export default function setupAppcues(): () => void {
  window.eventHub.$on('appcues:loaded', () => {
    trackVisit()
    setupAppcuesErrorMonitoring()
    void identifyStatusPageIncident()
  })

  reloadAppcues()

  return reloadAppcues
}
